import Vue from 'vue'

export const state = Vue.observable({ appInfoResp: Object })


export function requestappInfo(callBack) {
    window.clientInfoCallback = (info) => {
        if (typeof info === 'string') {
            info = JSON.parse(info)
        }
        state.appInfoResp = info
        if(callBack){
            callBack(info)
        }
    }
    if (window.goods) {
        window.goods.getClientInfo(`clientInfoCallback`)
    }
}

export function isIOS() {
    return state.appInfoResp.platform === 'ios'
}
export function isAndroid() {
    return state.appInfoResp.platform === 'android'
}

export function getStatusHeight() {
    if (state.appInfoResp.platform === 'ios') {
        return state.appInfoResp.statusBarHeight
    }
    return document.documentElement.clientHeight * state.appInfoResp.statusBarHeight / state.appInfoResp.screenHeight
}

export function getAppInfo() {
    return state.appInfoResp
}

export function titleStatusBarHeight() {
    return state.appInfoResp.statusBarHeight + state.appInfoResp.titleBarHeight
}

// const TYPE_NONE = -1
// const TYPE_PHONE = 2
const TYPE_GUEST = 4

export function isGuest() {
    if (!state.appInfoResp.loginType || parseInt(state.appInfoResp.loginType) === TYPE_GUEST) {
        return true
    }
    return false
}


export default state